import RemoteEvaluator from "../../../../mode/remote/RemoteEvaluator"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import EvaluateRequest from "../../../../EvaluateRequest"
import RemoteConfigRemoteEvaluateRequest from "./RemoteConfigRemoteEvaluateRequest"
import RemoteConfigEvaluateResponse from "../../RemoteConfigEvaluateResponse"
import RemoteConfigEvaluateResult from "../../RemoteConfigEvaluateResult"
import EvaluationEventRecorder from "../../../../event/EvaluationEventRecorder"
import RemoteConfigEvaluator from "../../RemoteConfigEvaluator"

export default class RemoteConfigRemoteEvaluator
  extends RemoteEvaluator<RemoteConfigRemoteEvaluateRequest, RemoteConfigEvaluateResponse>
  implements RemoteConfigEvaluator<RemoteConfigRemoteEvaluateRequest>
{
  constructor(private readonly eventRecorder: EvaluationEventRecorder) {
    super()
  }

  supports(request: EvaluateRequest): request is RemoteConfigRemoteEvaluateRequest {
    return request instanceof RemoteConfigRemoteEvaluateRequest
  }

  protected remoteEvaluate(
    request: RemoteConfigRemoteEvaluateRequest,
    context: EvaluatorContext
  ): RemoteConfigEvaluateResponse {
    // The reason is re-attributed to TYPE_MISMATCH when the server value fails the caller's required
    // type; the value is kept so the decision layer can fall back to the caller's default.
    const result = RemoteConfigEvaluateResult.fromRequest(request, request.entity.reason, request.entity.value)
    return RemoteConfigEvaluateResponse.of(request, context, result)
  }

  record(_request: RemoteConfigRemoteEvaluateRequest, response: RemoteConfigEvaluateResponse): void {
    this.eventRecorder.record(response)
  }
}
